/**
 * 监听路由改变
 */

import mitt from '@/utils/mitt'
import type { RouteLocationNormalized } from 'vue-router'
import { getRawRoute } from './helper/routerHelp'

const key = Symbol()

// 事件总线，发布/订阅模式
const emitter = mitt<Record<symbol, RouteLocationNormalized>>()

let lastChangeTab: RouteLocationNormalized

/**
 * 通知路由变化
 * @param lastChangeRoute 上一次路由
 */
export function notifyRouteChange(lastChangeRoute: RouteLocationNormalized) {
  const r = getRawRoute(lastChangeRoute)
  emitter.emit(key, r)
  lastChangeTab = r
}

/**
 * 监听路由变化
 * @param callback 回调函数
 * @param immediate 是否立即执行
 */
export function listenerRouteChange(
  callback: (route: RouteLocationNormalized) => void,
  immediate = true,
) {
  emitter.on(key, callback)
  immediate && lastChangeTab && callback(lastChangeTab)
}

/**
 * 移除路由监听
 */
export function removeRouteChangeListener() {
  emitter.clear()
}
